module.exports = __webpack_public_path__ + "img/vtuber_liver.1fc8a058.png";